export default "__VITE_ASSET__CqHox5WE__"